import type { MigrationStrategies } from "./_types/migration-strategies";

export const REFERRAL_FEEDBACK_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (_) => null,
  3: (_) => null,
};
